import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';

function ToastAlert(props) {
    const settings = {
        position: "top-right",
        closeButton: true,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored"
    };
    switch (props.msgType) {

        case 'success':

            toast.success(props.msg, settings);
            break;
        case 'info':

            toast.info(props.msg, settings);
            break;
        case 'warn':

            toast.warn(props.msg, settings);
            break;
        case 'error':

            toast.error(props.msg, settings);
            break;
        default:

            toast(props.msg, settings);
            break;
    }
}
export default ToastAlert;